import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { isDefined } from '@frontend/sports/common/core/utils/extended-types';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { BehaviorSubject, Observable, filter } from 'rxjs';

import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetBuilderPick } from '../../../models';

@Component({
    selector: 'bs-linear-bet-builder-pick-display-header',
    templateUrl: './linear-bet-builder-pick-display-header.component.html',
    styleUrls: ['./linear-bet-builder-pick-display-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderPickDisplayHeaderComponent implements OnChanges {
    @Input() pick: BetBuilderPick;
    @Input() selectionState?: { isSelected: boolean; isLocked: boolean };
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() betslipType: BetslipType;
    @Input() showWarnings: boolean;
    @Input() hideOdds = false;

    private pickChangeSubject = new BehaviorSubject<BetslipPick | undefined>(undefined);
    pickChange$: Observable<BetslipPick> = this.pickChangeSubject.asObservable().pipe(filter(isDefined));

    ngOnChanges(changes: ISimpleChanges<LinearBetBuilderPickDisplayHeaderComponent>): void {
        if (changes.pick?.currentValue) {
            this.pickChangeSubject.next(changes.pick.currentValue);
        }
    }

    get headerTitle(): string {
        return this.pick.eventName.name;
    }
}
